<template>
  <!-- FOOTER 
  =============================================-->
  <section>
    <div class="clear"></div>
    <div
      class="row ft-reponsive"
    >
      <div class="col-lg-3 col-md-3 col-5" style="text-align: center; ">
        <img :src="getApiPath('a8ca6b9f-e7f1-43e2-b23d-12840b697b8d.png')" alt="Wintershop Thailand" style="margin-right: 20px;" />
      </div>

      <div class="col-lg-3 col-md-3 col-7">
        <div class="fancy-title title-border">
          <h4> CHERTAM1991 </h4>
        </div>
         <p class="responsive-ft-font">
          พบกับเราได้ที่สาขาใหญ่หน้าร้าน
          <br />Line : @CHERTAM1991
          <br />เปิดบริการ 09:00-18:00 
          <br /> จองออนไลน์ตลอด 24 ชม. 
        </p>
      </div>

      <div class="col-lg-6 col-md-6 col-12">
        <div class="fancy-title title-border">
          <h4>Connect with Us</h4>
        </div>
        <div class="row">
          <div class="social_banner col-lg-4 col-md-4 col-4">
            <img
              :src="getFullPath('fb.jpg')"
              style="cursor:pointer; border-radius:10px;"
              @click="redirectToExternal('https://www.facebook.com/Chertam1991')"
            />
          </div>
          <div class="social_banner col-lg-4 col-md-4 col-4">
            <img
              :src="getFullPath('ig_banner.jpg')"
              style="cursor:pointer;; border-radius:10px;"
             @click="redirectToExternal('https://www.instagram.com/CHERTAM1991')"
            />
          </div>
          <div class="social_banner col-lg-4 col-md-4 col-4">
            <img
              :src="getFullPath('line_banner.jpg')"
              style="cursor:pointer;  border-radius:10px;"
              @click="redirectToExternal('https://lin.ee/1jFn3US')"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- row -->
</template>
<script>
import store from "@/store.js";
import myMixins from "@/mixins/myMixins.js";
export default {
  mixins: [myMixins],
  data() {
    return {};
  },
  methods: {
    getFullPath(mainImage) {
      if (mainImage === undefined || mainImage === null || mainImage === "") {
        return store.state.imageUrl + "defaultimage.png";
      } else {
        return store.state.imageUrl + mainImage;
      }
    }
  },
  components: {}
};
</script>
 
<style >
.ft-reponsive{
      max-width: 1100px; 
      margin-left: auto; 
      margin-right: auto; 
      margin-top: 90px; 
      padding-bottom: 40px;
  }
@media only screen and (max-width: 800px) {
  .ft-reponsive{
      margin-left: auto; 
      margin-right: auto; 
      margin-top: 0 !important; 
      padding-bottom: 40px;
      margin-bottom: 220px !important;
  }
  .responsive-ft-font{
    font-size: 0.6rem !important;
  }
  .fancy-title {
    position: relative;
    margin-bottom: 10px !important;
    margin-top: 10px !important;
    font-size: 0.8rem !important;
} 
}

</style>